export const siteSettings = {
  name: "GTX Trading",
  link: "https://gtxtrading.net",
  email: "support@gtxtrading.net",
  appLink: "https://app.gtxtrading.net",
};
